export default __webpack_public_path__ + "static/media/uploadServices.e9e8d5c0.svg";